export interface Bonus {
  title: string
  desc: string
  cover: string
}

// Los 5 bonos actuales de Impultienda.
export const BONUSES: Bonus[] = [
  {
    title: 'Lista de Control Clínico de Valoración Inicial',
    desc: 'Para no omitir nada en el primer contacto.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d56c93ad-9e5b-451d-b17b-45fa9a122c1c.jpg',
  },
  {
    title: 'Tabla Maestra de Valores Normales y Signos de Alarma',
    desc: 'Referencia rápida para interpretar signos vitales.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a9ac51a3-08d5-4831-9f41-d053b067507b.jpg',
  },
  {
    title: 'Guía Express de Medicación y Cálculos',
    desc: 'Dosis, goteo y los 10 correctos en un solo lugar.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d975faa9-9bc4-4cd5-9804-4ed6c41e3ac1.jpg',
  },
  {
    title: 'Plan de Estudio Clínico de 21 Días',
    desc: 'Una ruta clara para avanzar con orden y foco.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6a7e6d02-dd44-4b58-a454-4e563f080158.jpg',
  },
  {
    title: 'Red Flags Hospitalarios y Deterioro Clínico',
    desc: 'Identificar señales de alarma a tiempo.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f0d93c11-024f-4104-95b7-83a0587b1118.jpg',
  },
]
